import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';
/** Pass untouched request through to the next request handler. */
@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  constructor(private authService: LoginService) {

  }


  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    let identificador = location.hostname.replace('http://', '').replace('https://', '').split('.')[0];
    identificador = identificador.replace('localhost', 'prueba');
    //identificador = 'prueba';
    const token = this.authService.token;
    if ( !req.url.toString().includes('https://toolsmexico-pdfbuilder-api.uc.r.appspot.com/pdf/cfdi/generico/pdf')
      && !req.url.toString().includes('https://toolsmexico-pdfbuilder-api.uc.r.appspot.com/pdf/cfdi/generico/zip')
      && !req.url.toString().includes('http://localhost:8080/pdf/cfdi/generico/pdf')
      && !req.url.toString().includes('http://localhost:8080/pdf/cfdi/generico/zip')
      && !req.url.toString().includes('https://pdfawsbuilder.tnk.mx/pdf/cfdi/generico/pdf')
      && !req.url.toString().includes('https://pdfawsbuilder.tnk.mx/pdf/cfdi/generico/zip')) {
      if (token != null) {
        let authReq = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + token),
        });
        authReq = authReq.clone({
          headers: authReq.headers.set('sub-domain', identificador),
        });
        return next.handle(authReq);
      }
    }
    const req_domain = req.clone({
      headers: req.headers.set('sub-domain', identificador),
    });
    return next.handle(req_domain);
  }

}
